import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from '../../../icons/close.svg';

import './modal.scss';

export const Modal = ({
  title,
  isOpen,
  onClose,
  children,
  small = false,
  className = '',
  width = 700,
  minHeight = '90vh'
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const memoizedSize = useMemo(
    () => ({ width: small ? 350 : width, minHeight: small ? '40vh' : minHeight }),
    [small, width, minHeight]
  );

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal">
      <div className="modal__overlay" onClick={onClose} />
      <div className={`modal__content ${className}`} style={{ ...memoizedSize }}>
        <div>
          <span>{title}</span>
          <button className="modal__close" onClick={onClose}>
            <CloseIcon width={24} height={24} />
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>,
    document.body
  );
};
